((app, ng)=> {

    app.controller("addCustomFieldController", addCustomFieldController);

    function addCustomFieldController(customFieldApi, _formPattern, $mdDialog, $scope, $state) {
        const $ctrl = this;
        ng.extend($ctrl, {
            datePicker: {
                days: [],
                months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sept", "Oct", "Nov", "Dec"],
                years: []
            },
            domainTypes:
                [
                    { Id: '1', Name: 'Contact (Personal)', Value: 'Client' },
                    { Id: '2', Name: 'Insurance Account', Value: 'InsuranceAccount' },
                    { Id: '3', Name: 'Investment Account', Value: 'InvestmentAccount' },
                    { Id: '4', Name: 'All Accounts', Value: 'AllAccounts' }
                ],
            customFieldTypes: [
                { Id: 1, Name: 'Text', Value: 'Text' },
                { Id: 2, Name: 'Text Area', Value: 'TextArea' },
                { Id: 3, Name: 'Drop-down List', Value: 'DropDownList ' },
                { Id: 4, Name: 'Radio List', Value: 'RadioList' },
                { Id: 5, Name: 'Date', Value: 'DateTime' }
                //{ Id: 5, Name: 'Checkbox List', Value: 'CheckboxList' }
                //{ Id: 4, Name: 'Radio', Value: 'Radio' },
                //{ Id: 6, Name: 'Checkbox', Value: 'Checkbox' },
            ],
            customField: {
                CustomFieldType: 'Text',
                IsActive: true,
                IsTextField: true,
                TextOptionsList: []
            },
            newOption: "",
            formPattern: _formPattern
        });

        $ctrl.onInit = () => {
        };

        $ctrl.close = () => {
            $mdDialog.hide();
        };

        $ctrl.updateModel = (customField, selectedType) => {
            customField.IsTextField = selectedType === "Text" || selectedType === "TextArea"
                ? true
                : false;
            return customField;
        };

        $ctrl.addOptions = (option) => {
            // check that option is not already in the list
            var searchTerm = option.toLowerCase();
            if (!!option && $ctrl.customField.TextOptionsList.length < 1 ) {
                $ctrl.customField.TextOptionsList.push(option);
                $ctrl.newOption = null;
            } else if (!!option && !!$ctrl.customField.TextOptionsList && !_.find($ctrl.customField.TextOptionsList, function (row) { return row.toLowerCase() === searchTerm;})) {
                $ctrl.customField.TextOptionsList.push(option);
                $ctrl.newOption = null;
            } 
        };

        $ctrl.removeOption = (option) => {
            $ctrl.customField.TextOptionsList = _.remove($ctrl.customField.TextOptionsList, (activeOption) => {
                return activeOption !== option;
            });
        };

        $ctrl.createCustomField = (customField, $event) => {
            $ctrl.loading = true;
            //customField.IsTextField = !!customField.TxtOptionsList : fals
            return customFieldApi.add(customField)
                .then((response) => {
                    $ctrl.close($event);
                    return $state.go("Home.Settings.CRMSetup.CustomFields", {}, { reload: true });
                })
                .catch(error => { console.log(error); })
                .finally(() => {
                    $ctrl.loading = false;
                });
        };

        $scope.enterCheck = (e) => {
            if (e.which === 13 || e.keyCode === 13) {
                return $ctrl.addOptions($ctrl.newOption);
            } else { return false; }
        };
    }

})(window.app, window.angular);